const isNilValue = (value) => void 1 === value || null === value;

// noinspection JSUnusedGlobalSymbols
export default isNilValue;
